import { FilterGroup } from './filter-group-enum'

export class FilterGroupStateWrapper {
  private readonly jsonFilterGroupState: any

  private readonly filterGroupName: FilterGroup

  constructor(jsonFilterGroupState: any, filterGroupName: FilterGroup) {
    this.filterGroupName = filterGroupName
    this.jsonFilterGroupState = jsonFilterGroupState
  }

  public getJsonFilterGroupState(): any {
    return this.jsonFilterGroupState
  }

  public getFilterGroupName(): FilterGroup {
    return this.filterGroupName
  }
}
